import moment from 'moment';

export const groupProgramAnswerEntity = (data: any, programBookAnswers: any, seanceDate: any) => {
    const answers = programBookAnswers.data.list;

    if (data?.values) {
        data.values.forEach((section: any, i: number) => {
            const targets: any = [];
            section.values.forEach((domain: any, j: number) => {
                domain.values.forEach((longTerm: any, k: number) => {
                    longTerm.values.forEach((shortTerm: any, l: number) => {
                        shortTerm.targets.forEach((target: any, m: number) => {
                            const answer = answers.find((its: any) => its.programTarget?.id === target.id);
                            target.answer = answer && answer.answer ? answer.answer : '';
                            if (answer) {
                                answer.isSkip = answer.isSkip == true ? 1 : answer.isSkip == false ? 0 : answer.isSkip;
                            }
                            target.isSkip = answer ? answer.isSkip : 1;
                            const programTargetOptionPrompts = target.programTargetPrompts;

                            const prompts: any[] = [];
                            let keyPrompt = 0;
                            const sel: any = [];
                            const selTitles: any = [];
                            Object.values(target.programTargetPrompts).forEach((targetPrompt: any, m: number) => {
                                if (targetPrompt.checked) {
                                    const promptAnswer = answer?.programTargetPromptsAnswers?.find(
                                        (its: any) => its.programTargetPrompt?.id === targetPrompt.id,
                                    );
                                    targetPrompt.checked = promptAnswer ? true : false;
                                    prompts[keyPrompt] = targetPrompt;
                                    if (targetPrompt.checked == true) {
                                        sel.push(targetPrompt.id);
                                        selTitles.push(targetPrompt.title);
                                    }
                                    keyPrompt++;
                                }
                            });
                            target.programTargetPrompts = prompts.length ? prompts : null;

                            if (target.type !== 1) {
                                target.promptItem = null;
                                if (prompts.find((its: any) => its?.checked == true) !== undefined) {
                                    target.promptItem = prompts.find((its: any) => its?.checked == true);
                                }
                            } else {
                                target.promptItemSelected = sel ? sel.join(',') : '';
                                target.promptItemSelectedLabels = selTitles ? selTitles.join(',') : '';
                            }

                            const options: any[] = [];
                            let key = 0;

                            Object.values(target.programTargetOptions).forEach((targetOption: any, m: number) => {
                                const promptOptions: any[] = [];
                                let keyPromptOption = 0;

                                const optionAnswer = answer?.programTargetOptionsAnswers?.find(
                                    (its: any) => its.programTargetOption?.id === targetOption.id,
                                );
                                target?.programTargetPrompts?.forEach((targetOptionPrompt: any, m: number) => {
                                    const promptOptionAnswer = optionAnswer?.programTargetOptionPromptAnswers?.find(
                                        (its: any) => its.programTargetPrompt?.id === targetOptionPrompt.id,
                                    );
                                    targetOptionPrompt.checked = promptOptionAnswer ? true : false;
                                    promptOptions[keyPromptOption] = targetOptionPrompt;
                                    keyPromptOption++;
                                });

                                targetOption.answer = optionAnswer ? optionAnswer.answer : '';
                                targetOption.programTargetPrompts = promptOptions.length ? promptOptions : null;

                                targetOption.promptItem = null;
                                if (promptOptions.find((its: any) => its?.checked == true) !== undefined) {
                                    targetOption.promptItem = promptOptions.find((its: any) => its?.checked == true);
                                }
                                options[key] = targetOption;
                                key++;
                            });
                            target.programTargetOptions = options;

                            //find active phase
                            const activePhase = target?.programTargetPhases?.find(
                                (its: any) =>
                                    (moment(seanceDate, 'YYYY-MM-DD').isSameOrAfter(
                                        moment(its.startDate, 'YYYY-MM-DD'),
                                    ) &&
                                        moment(seanceDate, 'YYYY-MM-DD').isSameOrBefore(
                                            moment(its.endDate, 'YYYY-MM-DD'),
                                        )) ||
                                    (moment(seanceDate, 'YYYY-MM-DD').isSameOrAfter(
                                        moment(its.startDate, 'YYYY-MM-DD'),
                                    ) &&
                                        its.endDate == null),
                            );
                            if (activePhase) {
                                const phaseAnswer = answer?.programTargetPhaseAnswers?.find(
                                    (its: any) => its.programTargetPhase?.id === activePhase.id,
                                );
                                activePhase.answer = phaseAnswer ? phaseAnswer.answer : '';

                                const phaseOptions: any[] = [];
                                key = 0;
                                Object.values(activePhase.programTargetPhaseOptions).forEach(
                                    (phaseOption: any, m: number) => {
                                        const phaseOptionAnswer = phaseAnswer?.programTargetPhaseOptionsAnswers?.find(
                                            (its: any) => its.programTargetPhaseOption?.id === phaseOption.id,
                                        );
                                        phaseOption.answer = phaseOptionAnswer ? phaseOptionAnswer.answer : '';
                                        phaseOptions[key] = phaseOption;
                                        key++;
                                    },
                                );
                                activePhase.programTargetPhaseOptions = phaseOptions;
                            }

                            target.activePhase = activePhase ? activePhase : null;

                            data.values[i].values[j].values[k].values[l].targets[m] = target;
                            targets.push(target);
                        });
                    });
                });
            });
            data.values[i].targets = targets;
        });
    }

    return data;
};
